<template>
  <div class="card card-custom gutter-b">
    <div class="card-header d-flex justify-content-between align-items-center">
      <div class="card-title">
        <h3 class="card-label">Danh sách trả góp Citime</h3>
      </div>

      <div class="card-title">
        <el-button :loading="is_export_excel" :disabled="is_export_excel" type="primary" size="mini" class="text-white" @click="exportExcelCitime">
<!--          <i class="el-icon-download text-white"></i>-->
          Xuất excel
        </el-button>

        <el-button :loading="is_export_excel" :disabled="is_export_excel" type="success" size="mini" class="text-white" @click="exportExcelFeesCitime">
          <!--          <i class="el-icon-download text-white"></i>-->
          Xuất excel phí trả góp
        </el-button>
      </div>
    </div>

    <div class="card-body">
      <!-- Filters -->
      <div class="row filter_form mt-2">
        <div class="form-group col-md-3">
          <span class="text-body">Học viên</span>
          <el-input
              class="mt-2"
              placeholder="Nhập mã học viên, SĐT, tên học viên"
              v-model.trim="query.student"
              clearable
              @input="onTypingSearch"
              @clear="onSearch"
          />
        </div>

        <div class="form-group col-md-3">
          <span class="text-body">Người trả góp</span>
          <el-input
              class="mt-2"
              placeholder="Nhập SĐT, tên người trả góp"
              v-model.trim="query.payer"
              clearable
              @input="onTypingSearch"
          />
        </div>

        <div class="form-group col-md-3">
          <span class="text-body">Thời hạn trả góp</span>
          <el-date-picker
              class="mt-2"
              v-model="query.date_range"
              clearable
              format="dd/MM/yyyy"
              value-format="yyyy-MM-dd"
              type="daterange"
              start-placeholder="Từ ngày"
              end-placeholder="Đến ngày"
              style="width: 100%"
              @input="onTypingSearch"
          />
        </div>

        <div class="form-group col-md-3">
          <span class="text-body">Trạng thái</span>
          <el-select
              class="mt-2"
              multiple
              v-model="query.status"
              clearable
              placeholder="Chọn trạng thái"
              style="width: 100%"
              @change="onSearch"
          >
            <el-option
                v-for="it in statusOptions"
                :key="it.value"
                :label="it.label"
                :value="it.value"
            />
          </el-select>
        </div>
      </div>

      <!-- Summary -->
      <div class="d-flex flex-wrap mb-3 text-muted" style="gap: 24px">
        <div>Số KH tất toán: <b>{{ summary.paid_off }}</b></div>
        <div>Số KH huỷ hợp đồng: <b>{{ summary.cancelled }}</b></div>
        <div>Số KH chưa thanh toán: <b>{{ summary.unpaid }}</b></div>
      </div>

      <!-- Table -->
      <DoubleScrollbar class="table-responsive overflow-auto">
        <table class="table table-vertical-center table-bordered mb-0" style="min-width: 1400px;">
          <thead>
          <tr>
            <th style="width: 60px;">#</th>
            <th>Người trả góp</th>
            <th>Số điện thoại</th>
            <th>Học viên</th>
            <th>Mã học viên</th>
            <th>Thời gian trả góp</th>
            <th>Số tiền vay</th>
            <th>Thời hạn trả</th>
            <th>Kỳ trả góp</th>
            <th>Số tiền trả góp</th>
            <th>Ngân hàng</th>
            <th>Trạng thái xử lý</th>
            <th>Thời gian thanh toán</th>
            <th>Công nợ</th>
            <th style="width: 140px;">Hành động</th>
          </tr>
          </thead>

          <tbody v-loading="loading">
          <tr v-if="rows.length === 0">
            <td colspan="15" class="text-center py-4 text-muted">
              Không có dữ liệu
            </td>
          </tr>

          <tr v-for="(r, idx) in rows" :key="r.id">
            <td>{{ (paging.current_page - 1) * paging.per_page + idx + 1 }}</td>
            <td>{{ r.nguoi_tra_gop }}</td>
            <td>{{ r.sdt_nguoi_tra_gop }}</td>
            <td>{{ r.hoc_vien }}</td>
            <td>{{ r.ma_hv + 100000 }}</td>
            <td>{{ r.thoi_gian_tra_gop }}</td>
            <td>{{ r.so_tien_vay | formatVND}}</td>
            <td>{{ r.thoi_han_tra }}</td>
            <td>{{ r.period }}</td>
            <td>{{ r.so_tien_tra_gop | formatVND }}</td>
            <td>{{ r.ngan_hang }}</td>
            <td>
              <el-tag
                  size="small"
                  style="border: none"
                  class="w-100 text-center"
                  :style="statusTagType(r.trang_thai_xu_ly_label)"
                  effect="dark"
              >
                {{ r.trang_thai_xu_ly_label }}
              </el-tag>
            </td>
            <td>{{ r.thoi_gian_thanh_toan }}</td>
            <td>{{ r.cong_no | formatVND }}</td>
            <td>
              <a @click="openDialogExtend(r)" class="btn btn-sm btn-icon btn-outline-danger mr-2"><i class="el-icon-date"></i></a>
              <a @click="openDialogHandlePaymentSlow(r)" class="btn btn-sm btn-icon btn-outline-primary mr-2"><i class="el-icon-money"></i></a>
              <a @click="openDialogHandlePaymentBill(r)" class="btn btn-sm btn-icon btn-outline-warning"><i class="el-icon-postcard"></i></a>
              <a v-if="canShowPaymentInfo(r)" @click="openDialogPaymentInfo(r)" title="Xem thông tin thanh toán" class="btn btn-sm btn-icon btn-outline-success ml-2"><i class="el-icon-bank-card"></i></a>
            </td>
          </tr>
          </tbody>
        </table>
      </DoubleScrollbar>

      <!-- Pagination -->
      <div class="d-flex justify-content-center mt-4">
        <el-pagination
            background
            layout="prev, pager, next"
            :total="paging.total"
            :page-size="paging.per_page"
            :current-page="paging.current_page"
            @current-change="onPageChange"
          >
        </el-pagination>
      </div>
    </div>
    <el-dialog title="Gia hạn thanh toán" class="dialog_extend" :visible.sync="dialogExtendPaymentVisible" top="30vh" width="20%">
      <hr>
      <span style="word-break: break-word; font-weight: 300">Chọn loại gia hạn và thời gian để gia hạn thanh toán cho khách hàng</span>
      <div class="mt-4">
        <el-radio-group v-model="extend.type" >
          <el-radio label="all_months">Gia hạn tất cả tháng</el-radio>
          <el-radio label="this_month">Gia hạn tháng này</el-radio>
        </el-radio-group>
        <div class="mt-2 mb-2">
          <el-date-picker
              class="w-100"
              v-model=extend.date
              type="date"
              placeholder="Chọn ngày gia hạn"
              >
          </el-date-picker>
        </div>

        <div class="d-flex justify-content-end mt-4">
          <el-button size="mini" style="background-color: #CACACA" class="rounded" @click="dialogExtendPaymentVisible=false">Hủy bỏ</el-button>
          <el-button @click="extendCitime()" size="mini" class="text-white rounded" style="background-color: #5D04B0" :loading="loadingExtend" :disabled="loadingExtend">Xác nhận</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="Xử lý trả chậm cho khách hàng" class="dialog_extend" :visible.sync="dialogHandlePaymentSlowVisible" top="10vh" width="50%">
      <hr>
      <DialogHandlePaymentSlow :is_show="dialogHandlePaymentSlowVisible" @close="dialogHandlePaymentSlowVisible=false" :data="rowSelect"/>
    </el-dialog>

    <el-dialog title="Xử lý lỗi thanh toán" class="dialog_extend" :visible.sync="dialogHandlePaymentBillVisible" top="10vh" width="30%">
      <hr>
      <DialogHandlePaymentBill :is_show="dialogHandlePaymentBillVisible" @close="dialogHandlePaymentBillVisible=false" @reload="fetchList()" :data="rowSelect"/>
    </el-dialog>

    <el-dialog title="Thông tin thanh toán công nợ" class="dialog_extend" :visible.sync="dialogPaymentInfoVisible" top="10vh" width="40%">
      <hr>
      <DialogPaymentInfo v-if="dialogPaymentInfoVisible" :data="rowSelect" @close="dialogPaymentInfoVisible=false"/>
    </el-dialog>

  </div>
</template>

<script>
import DoubleScrollbar from "@/view/content/DoubleScrollbar";
import {EXTEND_DATElINE_CITIME, GET_TYPE_EXTEND, GET_LIST_CITIME, EXPORT_LIST_CITIME} from "@/core/services/store/citime/citime.module";
import moment from 'moment';
import {SET_BREADCRUMB} from "../../../core/services/store/breadcrumbs.module";
import DialogHandlePaymentSlow from "./components/DialogHandlePaymentSlow.vue";
import DialogHandlePaymentBill from "./components/DialogHandlePaymentBill.vue";
import DialogPaymentInfo from "./components/DialogPaymentInfo.vue";
import {exportExcel} from "@/core/filters";

const debounce = (fn, wait = 300) => {
  let t;
  return function (...args) {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
};

export default {
  name: "citime-installment-list",
  components: {DialogHandlePaymentBill, DialogHandlePaymentSlow, DialogPaymentInfo, DoubleScrollbar },

  data() {
    return {
      loading: false,
      dialogExtendPaymentVisible: false,
      dialogHandlePaymentSlowVisible: false,
      dialogHandlePaymentBillVisible: false,
      dialogPaymentInfoVisible: false,
      is_export_excel: false,
      extend: {
        type: 'all_months',
        date: ''
      },
      rows: [],
      summary: {
        paid_off: 0,
        cancelled: 0,
        unpaid: 0,
      },
      statusOptions: [],
      query: {
        student: "",
        payer: "",
        status: [],
        date_range: [],
        page: 1,
        per_page: 10,
      },
      paging: {
        current_page: 1,
        last_page: 1,
        per_page: 10,
        total: 0,
      },
      rowSelect: null,
      loadingExtend: false
    };
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "citime" },
      { title: "Trả góp Citime" },
    ]);
    this.getTypeExtend()
  },

  created() {
    this.pullQueryFromUrl();
    this.fetchList();
  },

  watch: {
    dialogExtendPaymentVisible(val) {
      if (! val) {
        this.extend = {
          type: 'all_months',
          date: ''
        }
      }
    }
  },

  methods: {
    getTypeExtend() {
      this.$store.dispatch(GET_TYPE_EXTEND).then((res) => {
        this.statusOptions = res.data
      }).catch(() => {

      });
    },

    onTypingSearch: debounce(function () {
      this.onSearch();
    }, 350),

    onSearch() {
      this.query.page = 1;
      this.pushQueryToUrl();
      this.fetchList();
    },

    onPageChange(p) {
      this.query.page = p;
      this.pushQueryToUrl();
      this.fetchList();
    },

    pullQueryFromUrl() {
      const q = this.$route.query || {};
      this.query.student = q.student || "";
      this.query.payer = q.payer || "";
      this.query.status = q.status || [];
      this.query.page = Number(q.page || 1);
      this.query.per_page = Number(q.per_page || 10);

      if (q.start_date && q.end_date) {
        this.query.date_range = [q.start_date, q.end_date];
      } else {
        this.query.date_range = [];
      }
    },

    pushQueryToUrl() {
      const [start_date, end_date] = this.query.date_range?.length === 2 ? this.query.date_range : [null, null];

      this.$router.replace({
        query: {
          student: this.query.student || undefined,
          payer: this.query.payer || undefined,
          status: this.query.status || [],
          start_date: start_date || undefined,
          end_date: end_date || undefined,
          page: this.query.page,
          per_page: this.query.per_page,
        },
      });
    },
     fetchList() {
      this.loading = true
      const payload = {
        student_keyword: this.query.student,
        payer_keyword: this.query.payer,
        status: this.query.status ?? [],
        start_date: this.query.date_range?.[0] || null,
        end_date: this.query.date_range?.[1] || null,
        page: this.query.page,
        per_page: this.query.per_page,
      }

      this.$store.dispatch(GET_LIST_CITIME, payload).then((res) => {
        this.rows = res.data || [];
        this.paging = res.pagination || this.paging;
        this.loading = false
      }).catch(() => {
        this.loading = false
      });
    },

    statusTagType(status) {
      switch (status) {
        case "Chưa trả":
          return "background-color: #FF9900; color: #000000";
        case "Hoàn thành":
          return "background-color: #187700;";
        case "Đã trả":
          return "background-color: #0066FF;";
        case "Hủy hợp đồng":
          return "background-color: #B5B5B5;";
        case "Thanh toán thiếu":
          return "background-color: #EBEF6F; color: #000000";
        case "Quá hạn":
          return "background-color: #FF0000;";
        case "Trả chậm":
          return "background-color: #5F04B4;";
        default:
          return "";
      }
    },

    async exportExcelFeesCitime() {
      const HEADER_ROW_EXPORT_CITIME = [
        { key: 'stt', value: 'STT' },
        { key: 'nguoi_tra_gop', value: 'Người trả góp' },
        { key: 'sdt_nguoi_tra_gop', value: 'Số điện thoại' },
        { key: 'name_hoc_vien', value: 'Học viên' },
        { key: 'sdt_hoc_vien', value: 'Số điện thoại học viên' },
        { key: 'ma_hv', value: 'Mã học viên' },
        { key: 'so_tien_tra_gop', value: 'Phí trả góp' },
        { key: 'ngan_hang', value: 'Ngân hàng' },
        { key: 'trang_thai_xu_ly_label', value: 'Trạng thái xử lý' },
        { key: 'referenceCode', value: 'Mã giao dịch ngân hàng' },
        { key: 'thoi_gian_thanh_toan', value: 'Thời gian thanh toán' },
        { key: 'branch_id', value: 'ID chi nhánh' },
        { key: 'branch_name', value: 'Tên chi nhánh' },
        { key: 'center_id', value: 'ID trung tâm' },
        { key: 'center_name', value: 'Tên trung tâm' },
        { key: 'bank_account_number', value: 'Tài khoản ngân hàng' }
      ]

      this.is_export_excel = true

      const queryExport = {
        student_keyword: this.query.student,
        payer_keyword: this.query.payer,
        status: this.query.status ?? [],
        start_date: this.query.date_range?.[0] || null,
        end_date: this.query.date_range?.[1] || null,
        installment_fee: 1,
        is_export: 1,
      }

      try {
        const res = await this.$store.dispatch(
            EXPORT_LIST_CITIME,
            queryExport
        )

        if (res.data.error) {
          this.$bvToast.toast(res.data.message, {
            title: 'Export excel',
            variant: 'danger',
            solid: true,
          })

          return
        }

        exportExcel(
            HEADER_ROW_EXPORT_CITIME,
            res.data.data ?? res.data,
            'Danh sách trả góp.xlsx',
            true
        )
      } finally {
        this.is_export_excel = false
      }
    },

    async exportExcelCitime() {
      const HEADER_ROW_EXPORT_CITIME = [
        { key: 'stt', value: 'STT' },
        { key: 'nguoi_tra_gop', value: 'Người trả góp' },
        { key: 'sdt_nguoi_tra_gop', value: 'Số điện thoại' },
        { key: 'name_hoc_vien', value: 'Học viên' },
        { key: 'sdt_hoc_vien', value: 'Số điện thoại học viên' },
        { key: 'ma_hv', value: 'Mã học viên' },
        { key: 'thoi_gian_tra_gop', value: 'Thời gian trả góp' },
        { key: 'so_tien_vay', value: 'Số tiền vay' },
        { key: 'thoi_han_tra', value: 'Kỳ hạn' },
        { key: 'start_paid', value: "Bắt đầu trả" },
        { key: 'end_paid_expected', value: 'Dự kiến kết thúc trả' },
        { key: 'so_tien_tra_gop', value: 'Số tiền trả góp' },
        { key: 'ngan_hang', value: 'Ngân hàng' },
        { key: 'trang_thai_xu_ly_label', value: 'Trạng thái xử lý' },
        { key: 'referenceCode', value: 'Mã giao dịch ngân hàng' },
        { key: 'thoi_gian_thanh_toan', value: 'Thời gian thanh toán' },
        { key: 'branch_id', value: 'ID chi nhánh' },
        { key: 'branch_name', value: 'Tên chi nhánh' },
        { key: 'center_id', value: 'ID trung tâm' },
        { key: 'center_name', value: 'Tên trung tâm' },
        { key: 'bank_account_number', value: 'Tài khoản ngân hàng' },
      ]

      this.is_export_excel = true

      const queryExport = {
        student_keyword: this.query.student,
        payer_keyword: this.query.payer,
        status: this.query.status ?? [],
        start_date: this.query.date_range?.[0] || null,
        end_date: this.query.date_range?.[1] || null,
        is_export: 1,
      }

      try {
        const res = await this.$store.dispatch(
            EXPORT_LIST_CITIME,
            queryExport
        )

        if (res.data.error) {
          this.$bvToast.toast(res.data.message, {
            title: 'Export excel',
            variant: 'danger',
            solid: true,
          })

          return
        }

        exportExcel(
            HEADER_ROW_EXPORT_CITIME,
            res.data.data ?? res.data,
            'Danh sách trả góp.xlsx',
            true
        )
      } finally {
        this.is_export_excel = false
      }
    },

    openDialogExtend(item) {
      this.dialogExtendPaymentVisible = true;
      this.rowSelect = item;
    },

    openDialogHandlePaymentSlow(item) {
      this.rowSelect = item;
      this.dialogHandlePaymentSlowVisible = true;
    },

    openDialogHandlePaymentBill(item) {
      this.rowSelect = item;
      this.dialogHandlePaymentBillVisible = true;
    },

    // Chỉ hiển thị QR Code với log đang ở trạng thái Chưa trả & Trả chậm
    canShowPaymentInfo(item) {
      const status = item?.trang_thai_xu_ly;
      if (status) return ['unpaid', 'late_payment'].includes(status);

      return ['Chưa trả', 'Trả chậm'].includes(item?.trang_thai_xu_ly_label);
    },

    openDialogPaymentInfo(item) {
      this.rowSelect = item;
      this.dialogPaymentInfoVisible = true;
    },


    extendCitime(){
      this.loadingExtend = true;
      let typeExtend = this.extend.type;
      const payload = {
        payment_id: this.rowSelect.id,
        extension_type: typeExtend,
        new_due_date: this.extend.date
      }

      let selectedDate = new Date(this.extend.date);
      if(typeExtend === 'all_months') {
        selectedDate = moment(selectedDate).format('DD');
        if(selectedDate > 30) {
          this.$notify({
            title: 'Sai dữ liệu!',
            message: 'Ngày gia hạn tất cả tháng không được lớn hơn ngày 30',
            type: 'warning'
          });
          this.extend.date = '';
          this.loadingExtend = false;
          return
        }
        payload.new_day = parseInt(selectedDate);
        payload.new_due_date = '';
      } else {
        selectedDate = moment(selectedDate).format('YYYY-MM-DD');
        payload.new_due_date = selectedDate;
        payload.new_day = '';
      }

      this.$store.dispatch(EXTEND_DATElINE_CITIME, payload).then((res) => {
          this.$notify({
            title: 'Thành công!',
            message: res.message ?? 'Gia hạn thành công!',
            type: 'success'
          });
          this.fetchList();
        this.loadingExtend = false;
        this.dialogExtendPaymentVisible =  false;
      }).catch((e) => {
        this.loadingExtend = false;
        this.$notify({
          title: 'Lỗi!',
          message: e.data.message ?? 'Gia hạn thất bại!',
          type: 'error'
        });
      });
    },
  },
};
</script>


<style scoped>
::v-deep .el-dialog__body {
  padding: 0px 20px 20px 20px
}
</style>
